/* Copyright IBM Corp. 2018 */
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { SdkMessageHandler, SdkMessageHandlerCallback } from './../../../../api';
import { createNavigateByPathHandler } from './../../../../utils';
import { WchLoggerService } from './../../logger/wch.logger.service';

const LOGGER = 'SdkNavigateByPathHandler';

/**
 * Executes a navigation event
 */
@Injectable()
export class SdkNavigateByPathHandler implements SdkMessageHandler {

    handle: SdkMessageHandlerCallback;

    constructor(@Inject(Router) router: Router,
        @Inject(WchLoggerService) loggerService: WchLoggerService) {
        // create the handler
        this.handle = createNavigateByPathHandler(path => router.navigateByUrl(path), loggerService.get(LOGGER));
    }

}
